import Button from 'src/app/atoms/Button/Button';
import { cssVar } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

const selectedStyles = css`
  background: ${cssVar('bg-primary')};
  box-shadow: ${cssVar('shadow-xs')};
  color: ${cssVar('text-primary')};
`;

export const ButtonWrapper = styled(Button)`
  border: none;
  background: transparent;
  color: ${cssVar('gray-light-500')};
  transition: all 0.2s ease-in-out;
  box-shadow: none;
  height: 100%;
  font-size: ${cssVar('font-size-text-md')};

  &:hover,
  &:focus {
    ${selectedStyles}
  }
`;

interface TabButtonContainerProps {
  $isSelected: boolean;
}

export const TabButtonContainer = styled.div<TabButtonContainerProps>`
  height: 100%;

  ${({ $isSelected }) =>
    !$isSelected
      ? ''
      : css`
          ${ButtonWrapper} {
            ${selectedStyles}
          }
        `}
`;
